import { render, staticRenderFns } from "./DesignDashboard.vue?vue&type=template&id=609f8b70&scoped=true&"
import script from "./DesignDashboard.vue?vue&type=script&lang=js&"
export * from "./DesignDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DesignDashboard.vue?vue&type=style&index=0&id=609f8b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609f8b70",
  null
  
)

export default component.exports